import { createClient } from 'contentful';

if (!process.env.REACT_APP_CONTENTFUL_SPACE_ID) {
  throw new Error('Contentful Space ID is required. Please add REACT_APP_CONTENTFUL_SPACE_ID to your .env file.');
}

if (!process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN) {
  throw new Error('Contentful Access Token is required. Please add REACT_APP_CONTENTFUL_ACCESS_TOKEN to your .env file.');
}

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master',
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
});

export const getEvent = async (eventId) => {
  try {
    const entry = await client.getEntry(eventId);
    return entry;
  } catch (error) {
    console.error('Error fetching event:', error);
    throw error;
  }
};

export const getAllEvents = async () => {
  try {
    const response = await client.getEntries({
      content_type: 'events',
      order: '-fields.date'
    });
    return response.items;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

// Helper function to get image URL from Contentful asset
export const getImageUrl = (asset) => {
  if (!asset) return null;
  return `https:${asset.fields.file.url}`;
};

// Helper function to get video URL from Contentful asset
export const getVideoUrl = (asset) => {
  if (!asset) return null;
  return `https:${asset.fields.file.url}`;
};

export default client; 
